/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLandscapeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-landscape"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.23 16.77L5.8 10.78Q6 10.5 6.28 10.38Q6.55 10.25 6.85 10.25Q7.15 10.25 7.42 10.38Q7.7 10.5 7.9 10.78L11.75 15.85Q11.9 16.05 12.1 16.15Q12.3 16.25 12.55 16.25Q13.18 16.25 13.45 15.7Q13.72 15.15 13.35 14.65L10.65 11.05Q10.38 10.7 10.38 10.25Q10.38 9.8 10.65 9.45L12.95 6.45Q13.15 6.17 13.43 6.05Q13.7 5.92 14 5.92Q14.3 5.92 14.57 6.05Q14.85 6.17 15.05 6.45L22.8 16.77Q23.3 17.43 22.94 18.16Q22.57 18.9 21.75 18.9L2.27 18.9Q1.45 18.9 1.09 18.16Q0.72 17.43 1.23 16.77Z" fill={color} />
    </svg>
  );
}
